export default __webpack_public_path__ + "5fd192d5929665ab9cfa365fb327591c.svg";